import { Middleware } from '@reduxjs/toolkit';
import { getSocket } from '../utils/socket';
import { setWishlist, setProductsToCart, setBonus, setDiscount, clearCart } from './UserSlice';
import { setRole, clearSession } from './AuthSlice';
import { fetchProducts } from './ProductSlice';

export const socketMiddleware: Middleware = (store) => {
    let bound = false;
    const refetchPrices = () => {
        (store.dispatch as any)(fetchProducts());
    };
    return (next) => (action) => {
        const result = next(action);
        if (action.type === 'auth/loginSuccess' && !bound) {
            const socket = getSocket();
            socket.auth = { token: action.payload.token };
            socket.connect();
            socket.on('user:role', (r) => {
                store.dispatch(setRole(r));
                // store.dispatch(clearCart());
                refetchPrices();
            });
            socket.on('user:wishlist', (w) => store.dispatch(setWishlist(w)));
            socket.on('user:cart', (c) => {
                store.dispatch(setProductsToCart(c));
                // store.dispatch(clearCart());
                refetchPrices();
            });
            socket.on('user:bonus', (b) => store.dispatch(setBonus(b)));
            socket.on('user:discount', (d) => store.dispatch(setDiscount(d)));
            socket.on('force:logout', () => store.dispatch(clearSession()));
            bound = true;
            refetchPrices();
        }
        if (action.type === 'auth/logout' || action.type === clearSession.type) {
            getSocket().disconnect();
            bound = false;
            store.dispatch(clearCart());
            refetchPrices();
        }
        return result;
    };
};
